import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export enum ArrowNarrowDirection {
  DOWN = 'down',
  RIGHT = 'right',
  UP = 'up',
}

const arrowNarrowPath: Record<ArrowNarrowDirection, string> = {
  [ArrowNarrowDirection.DOWN]: 'M12 4V20M6 14L12 20L18 14',
  [ArrowNarrowDirection.RIGHT]: 'M4 12H20M14 18L20 12L14 6',
  [ArrowNarrowDirection.UP]: 'M12 20V4M18 10L12 4L6 10',
};

export type ArrowNarrowIconProps = {
  direction?: ArrowNarrowDirection;
  strokeWidth?: number;
} & Omit<IconProps, 'strokeWidth'>;

export const ArrowNarrowIcon: FC<ArrowNarrowIconProps> = ({
  direction = ArrowNarrowDirection.UP,
  iconColor = '#344054',
  strokeWidth = 1.5,
  className,
  ...props
}) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d={arrowNarrowPath[direction]}
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
    />
  </svg>
);
